export default __webpack_public_path__ + "static/media/flag-paraguay.d46fea7d.svg";